import React, { useEffect } from 'react';
import {
    Modal,
    View,
    TouchableOpacity,
    Text,
    StyleSheet,
    Platform,
} from 'react-native';
import { useAuth } from '../lib/AuthContext';
import { useSession } from '../lib/SessionContext';
import AuthScreen from './AuthScreen';
import { canAccessMainApp } from '../utils/authHelpers';

export default function AuthModal() {
    const { showAuthModal, authModalConfig, closeAuth } = useAuth();
    const { session } = useSession();

    // Auto-close modal when user signs in (but not for anonymous users or switch account mode)
    useEffect(() => {
        if (canAccessMainApp(session) && showAuthModal && !authModalConfig.forSwitchAccount) {
            console.log('🔐 [AuthModal] Authenticated session detected, closing modal');
            closeAuth();
        }
    }, [session, showAuthModal, closeAuth, authModalConfig.forSwitchAccount]);

    return (
        <Modal
            visible={showAuthModal}
            animationType="slide"
            presentationStyle="pageSheet"
            onRequestClose={closeAuth}
            testID="auth-modal"
        >
            <View style={styles.authModalContainer}>
                <View style={styles.authModalHeader}>
                    <View style={{ flex: 1 }} />
                    <TouchableOpacity onPress={closeAuth} style={styles.closeButton} testID="auth-modal-close-button">
                        <Text style={styles.closeButtonText}>✕</Text>
                    </TouchableOpacity>
                </View>
                <View style={styles.authModalContent}>
                    <AuthScreen
                        mode={authModalConfig?.mode}
                        redirectTo={authModalConfig?.redirectTo}
                        forSwitchAccount={authModalConfig?.forSwitchAccount}
                        funnelContext={authModalConfig?.funnelContext}
                        initialEmail={authModalConfig?.loginHint}
                        copyVariant={authModalConfig?.copyVariant}
                    />
                </View>
            </View>
        </Modal>
    );
}

const styles = StyleSheet.create({
    authModalContainer: {
        flex: 1,
        backgroundColor: '#fafafa',
    },
    authModalHeader: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingHorizontal: 20,
        paddingTop: 10,
        paddingBottom: 10,
        backgroundColor: 'white',
        borderBottomWidth: 1,
        borderBottomColor: '#e5e7eb',
        ...(Platform.OS === 'web' && {
            maxWidth: 900,
            alignSelf: 'center',
            width: '100%',
            marginHorizontal: 'auto',
        }),
    },
    authModalContent: {
        flex: 1,
        paddingTop: 20,
    },
    closeButton: {
        padding: 8,
    },
    closeButtonText: {
        fontSize: 24,
        color: '#6b7280',
    },
});
